import { render, staticRenderFns } from "./PlantVarietyNoteType.vue?vue&type=template&id=3ab62478&"
import script from "./PlantVarietyNoteType.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyNoteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports